
import {
  Vue, Component, Prop,
} from 'vue-property-decorator';

import TaskDetailsTitle from '@/components/TaskDetailsTitle.vue';
import TaskC from '@/components/TaskC.vue';
import TaskP from '@/components/TaskP.vue';
import TaskO from '@/components/TaskO.vue';
import TaskCm from '@/components/TaskCm.vue';
import TaskS from '@/components/TaskS.vue';
import TaskA from '@/components/TaskA.vue';
import TaskV from '@/components/TaskV.vue';
import TaskM from '@/components/TaskM.vue';
import TaskI from '@/components/TaskI.vue';
import TaskR from '@/components/TaskR.vue';
import Step1 from '@/components/Step1.vue';
import Step2 from '@/components/Step2.vue';
import Step3 from '@/components/Step3.vue';
import Step4 from '@/components/Step4.vue';
import EcobonusCheck from '@/components/EcobonusCheck.vue';
import TaskResetDialog from '@/components/TaskResetDialog.vue';
import { Lead, StepNames, Task } from '@/types';

@Component({
  components: {
    TaskDetailsTitle,
    TaskC,
    TaskP,
    TaskO,
    TaskCm,
    TaskS,
    TaskA,
    TaskV,
    TaskM,
    TaskI,
    TaskR,
    EcobonusCheck,
    Step1,
    Step2,
    Step3,
    Step4,
    TaskResetDialog,
  },
})
export default class TaskDetails extends Vue {
  @Prop(Object) readonly task: Task | undefined;
  @Prop(String) readonly step: StepNames | undefined;
  @Prop({ type: Boolean, default: false }) readonly ecobonusCheck!: boolean;
  @Prop({ type: Boolean, default: false }) readonly readonly!: boolean;

  // Mostra le eventuali azioni possibili sul Task (Modifica, Reimposta)
  @Prop({ type: Boolean, default: undefined }) readonly showTitleActions: boolean | undefined;

  resetDialog = false

  get lead(): Lead | null {
    return this.$store.getters.currentLead;
  }

  get disabled() {
    return this.task && this.task.status === 'disabled';
  }

  get currentLeadStatus() {
    return this.isCurrentProject
      ? this.lead?.status
      : this.leadInfo?.status;
  }

  get isCurrentProject(): boolean {
    return Boolean(
      this.lead && this.task && this.lead.id === (this.task.childLeadId ?? this.task.LeadId),
    );
  }

  get leadInfo(): Lead | null {
    if (this.leadId
      && this.leadId in this.childLeads) return this.childLeads[this.leadId];

    if (this.leadId && this.lead
      && this.lead.id === this.leadId) return this.lead;

    return null;
  }

  get leadId(): number | null {
    if (this.task?.childLeadId && this.task.childLeadId) return this.task.childLeadId;

    // if (this.lead && this.lead.id) return this.lead.id;

    return this.task?.LeadId || null;
  }

  get childLeads() {
    // return this.$store.getters.currentChildren;
    return this.$store.getters.currentChildrenInfo;
  }

  get taskClass() {
    if (this.task) {
      if (this.currentLeadStatus === 'resolved' && !this.task.status) {
        return 'completed';
      }
      if (!this.task.status) {
        return '';
      }
      if (this.task.status === 'disabled') {
        return '';
      }
      if (this.task.status === 'completed') {
        return this.task.extraCosti ? 'completed' : 'completed';
      }
      if (this.task.status === 'error') {
        return 'error';
      }
      return '';
    }

    if (this.step && this.lead && this.step in this.lead) {
      switch (this.lead[this.step]) {
        case true:
          return 'completed';
        case false:
          return 'error';
        default:
          return '';
      }
    } else {
      return '';
    }
  }

  get expansionPanelClass() {
    if (this.currentLeadStatus === 'resolved' && !this.task?.status) {
      return '';
    }
    if (this.task) {
      return !this.task.status ? 'todo' : '';
    }
    if (this.step && this.lead && this.step in this.lead) {
      return this.lead[this.step] === null ? 'todo' : '';
    }
    return '';
  }

  get showActions(): boolean {
    // Ritorna false se la lavorazione è completata.
    // Se non è stata specificata la Prop showTitleActions,
    // visualizza le azioni soltanto se il Task non ha figlie.
    // Altrimenti visualizza le azioni soltanto se la Prop è true.
    if (this.currentLeadStatus === 'resolved' && !this.task?.status) {
      return false;
    }

    return this.showTitleActions === undefined
      ? this.task?.relationship !== 'father'
      : this.showTitleActions;
  }

  onEdit() {
    console.log(`${this.constructor.name}: onEdit()`); // eslint-disable-line no-console

    this.$emit('edit');
  }

  onReset() {
    console.log(`${this.constructor.name}: onReset()`); // eslint-disable-line no-console

    this.resetDialog = true;
  }

  onGoto(where: string) {
    console.log(`${this.constructor.name}: onGoto() where =`, where); // eslint-disable-line no-console

    this.$emit('goto', where);
  }
}
